// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"d9754472","393":"913a8e1b","542":"a23d7259","626":"f71af035"}[chunkId] + ".chunk.js";
};